import { PayloadAction } from '@reduxjs/toolkit';
import { CategoryState } from 'store/category/types';

interface SetGtmProductsDataActionPayload {
  gtmProducts: any[];
  merge: boolean;
}

const setGtmProductsDataReducer = (state: CategoryState, action: PayloadAction<SetGtmProductsDataActionPayload>) => {
  if (action.payload.merge) {
    state.gtmProductsData = {
      ...state.gtmProductsData,
      ...action.payload.gtmProducts,
    };
  } else {
    state.gtmProductsData = action.payload.gtmProducts;
  }
};

export default setGtmProductsDataReducer;
